module.exports = __webpack_public_path__ + "static/media/question-mark.877ebaee.svg";